import {Component} from "@angular/core";

@Component({
    selector: "fui-pin",
    styleUrls: ["./pin.component.scss"],
    templateUrl: "./pin.component.html"
})
export class FUIPinComponent {

}
